


// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { AiOutlinePlus, AiOutlineHistory } from "react-icons/ai";
// import { MdVerifiedUser } from "react-icons/md";
// import { RiWallet3Fill , RiBankCard2Fill } from "react-icons/ri";
// import { BsArrowRightShort, BsShieldCheck } from "react-icons/bs";
// import { LanguageContext } from "../Components/LanguageContext";
// import Rightcontainer from "../Components/Rightcontainer";
// // import "./Mywallet.css";

// const Mywallet = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   const translations = {
//     hi: {
//       wallet: "वॉलेट बैलेंस",
//       secure: "BAJIGERLUDO सुरक्षित कैश",
//       available: "कुल उपलब्ध शेष",
//       deposit: "डिपॉजिट",
//       winnings: "विनिंग्स",
//       history: "ट्रांजैक्शन हिस्ट्री",
//       add: "कैश जोड़ें",
//       withdraw: "पैसे निकालें",
//       verified: "वेरिफाइड",
//       encrypted: "256-बिट सुरक्षित एन्क्रिप्टेड गेटवे",
//     },
//     en: {
//       wallet: "Wallet Balance",
//       secure: "BAJIGERLUDO Secure Cash",
//       available: "AVAILABLE BALANCE",
//       deposit: "Deposit",
//       winnings: "Winnings",
//       history: "Transaction History",
//       add: "ADD CASH",
//       withdraw: "WITHDRAW MONEY",
//       verified: "Verified",
//       encrypted: "256-BIT SECURE ENCRYPTED GATEWAY",
//     },
//   };

//   const t = translations[language] || translations.en;

//   // Safe formatting helpers
//   const totalBalance = Number(user?.Wallet_balance || 0);
//   const winningsBalance = Number(user?.withdrawAmount || 0);
//   const depositBalance = Math.max(0, totalBalance - winningsBalance);

//   return (
//     <div className="sa-wallet-wrapper leftContainer mt-5 pt-5">
//       <div className="sa-wallet-container">
        
//         {/* Header Banner */}
//         <div className="sa-header">
//           <div className="sa-header-text">
//             <h1>{t.wallet}</h1>
//             <p>{t.secure}</p>
//           </div>
//           <div className="sa-wallet-icon-box">
//             <RiWallet3Fill />
//           </div>
//         </div>

//         {/* Main Available Balance Card */}
//         <div className="sa-main-balance-card">
//           <div className="sa-card-glow-bg"></div>
//           <div className="sa-balance-top">
//             <span className="sa-balance-label">{t.available}</span>
//             <div className="sa-verified-badge">
//               <MdVerifiedUser className="sa-badge-icon" />
//               <span>{t.verified}</span>
//             </div>
//           </div>
//           <div className="sa-balance-value">
//             <span className="currency-symbol">₹</span>
//             <span className="amount-number">{totalBalance.toFixed(2)}</span>
//           </div>
//         </div>

//         {/* Breakdown Stats Grid */}
//         <div className="sa-stats-grid">
//           <div className="sa-stat-box deposit-box">
//             <div className="sa-stat-header">
//               <span className="sa-stat-dot green"></span>
//               <span className="sa-stat-label" >{t.deposit}</span>
//             </div>
//             <span className="sa-stat-value">₹{depositBalance.toFixed(2)}</span>
//           </div>

//           <div className="sa-stat-box winnings-box">
//             <div className="sa-stat-header">
//               <span className="sa-stat-dot gold"></span>
//               <span className="sa-stat-label gold">{t.winnings}</span>
//             </div>
//             <span className="sa-stat-value gold">₹{winningsBalance.toFixed(2)}</span>
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className="sa-actions-grid">
//           <Link to="/addcase" className="sa-btn sa-btn-add">
//             <div className="sa-btn-icon-wrapper">
//               <AiOutlinePlus />
//             </div>
//             <span style={{ color: '#fff' }}>{t.add}</span>
//           </Link>

//           <Link to="/Withdrawopt" className="sa-btn sa-btn-withdraw">
//             <div className="sa-btn-icon-wrapper">
//               < RiBankCard2Fill/>
//             </div>
//             <span style={{ color: '#fff' }}>{t.withdraw}</span>
//           </Link>
//         </div>

//         {/* History Row */}
//         <Link to="/history" className="sa-history-row">
//           <div className="sa-history-left">
//             <div className="sa-hist-icon-box">
//               <AiOutlineHistory className="sa-hist-icon" />
//             </div>
//             <span style={{ color: '#fff' }}>{t.history}</span>
//           </div>
//           <BsArrowRightShort className="sa-arrow" />
//         </Link>

//         {/* Secure Footer Badge */}
//         <div className="sa-secure-footer">
//           <BsShieldCheck className="sa-shield-icon" />
//           <span>{t.encrypted}</span>
//         </div>

//       </div>

//       <div className="rightContainer mobile-hide">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Mywallet;




import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AiOutlinePlus, AiOutlineHistory } from "react-icons/ai";
import { MdVerifiedUser } from "react-icons/md";
import { RiWallet3Fill, RiBankCard2Fill } from "react-icons/ri";
import { BsArrowRightShort, BsShieldCheck } from "react-icons/bs";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";
// import "./Mywallet.css";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      wallet: "वॉलेट बैलेंस",
      secure: "BAJIGERLUDO सुरक्षित कैश",
      available: "कुल उपलब्ध शेष",
      deposit: "डिपॉजिट",
      winnings: "विनिंग्स",
      history: "ट्रांजैक्शन हिस्ट्री",
      add: "कैश जोड़ें",
      withdraw: "पैसे निकालें",
      verified: "वेरिफाइड",
      encrypted: "256-बिट सुरक्षित एन्क्रिप्टेड गेटवे",
    },
    en: {
      wallet: "Wallet Balance",
      secure: "BAJIGERLUDO Secure Cash",
      available: "AVAILABLE BALANCE",
      deposit: "Deposit",
      winnings: "Winnings",
      history: "Transaction History",
      add: "ADD CASH",
      withdraw: "WITHDRAW MONEY",
      verified: "Verified",
      encrypted: "256-BIT SECURE ENCRYPTED GATEWAY",
    },
  };

  const t = translations[language] || translations.en;

  // Safe formatting helpers
  const totalBalance = Number(user?.Wallet_balance || 0);
  const winningsBalance = Number(user?.withdrawAmount || 0);
  const depositBalance = Math.max(0, totalBalance - winningsBalance);

  return (
    <div className="sa-wallet-wrapper leftContainer mt-5 pt-5">
      {/* Background ambient lighting blur effects */}
      <div className="sa-ambient-glow sa-glow-1"></div>
      <div className="sa-ambient-glow sa-glow-2"></div>

      <div className="sa-wallet-container">
        {/* Header Banner */}
        <div className="sa-header">
          <div className="sa-header-text">
            <h1>{t.wallet}</h1>
            <p>{t.secure}</p>
          </div>
          <div className="sa-wallet-icon-box">
            <RiWallet3Fill />
          </div>
        </div>

        {/* Main Available Balance Hero Card */}
        <div className="sa-main-balance-card">
          <div className="sa-card-glow-bg"></div>
          <div className="sa-balance-top">
            <span className="sa-balance-label">{t.available}</span>
            <div className="sa-verified-badge">
              <MdVerifiedUser className="sa-badge-icon" />
              <span>{t.verified}</span>
            </div>
          </div>
          <div className="sa-balance-value">
            <span className="currency-symbol">₹</span>
            <span className="amount-number">{totalBalance.toFixed(2)}</span>
          </div>
        </div>

        {/* Breakdown Stats Grid */}
        <div className="sa-stats-grid">
          <div className="sa-stat-box deposit-box">
            <div className="sa-stat-header">
              <span className="sa-stat-dot green"></span>
              <span className="sa-stat-label">{t.deposit}</span>
            </div>
            <span className="sa-stat-value">₹{depositBalance.toFixed(2)}</span>
          </div>

          <div className="sa-stat-box winnings-box">
            <div className="sa-stat-header">
              <span className="sa-stat-dot gold"></span>
              <span className="sa-stat-label">{t.winnings}</span>
            </div>
            <span className="sa-stat-value">₹{winningsBalance.toFixed(2)}</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="sa-actions-grid">
          <Link to="/addcase" className="sa-btn sa-btn-add">
            <div className="sa-btn-icon-wrapper">
              <AiOutlinePlus />
            </div>
            <span>{t.add}</span>
          </Link>

          <Link to="/Withdrawopt" className="sa-btn sa-btn-withdraw">
            <div className="sa-btn-icon-wrapper">
              <RiBankCard2Fill />
            </div>
            <span>{t.withdraw}</span>
          </Link>
        </div>

        {/* History Row */}
        <Link to="/history" className="sa-history-row">
          <div className="sa-history-left">
            <div className="sa-hist-icon-box">
              <AiOutlineHistory className="sa-hist-icon" />
            </div>
            <span className="sa-hist-text">{t.history}</span>
          </div>
          <BsArrowRightShort className="sa-arrow" />
        </Link>

        {/* Secure Footer Badge */}
        <div className="sa-secure-footer">
          <BsShieldCheck className="sa-shield-icon" />
          <span>{t.encrypted}</span>
        </div>
      </div>

      <div className="rightContainer mobile-hide">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Mywallet;